export const TODAY_PRESET_DAYS = 0;

export const MENU_PERIOD_PRESETS = [
  // { label: "Today", days: TODAY_PRESET_DAYS },
  { label: "Last 7 days", days: 7 },
  { label: "Last 28 days", days: 28 },
  { label: "Last 13 weeks", days: 91 },
  { label: "Last 52 weeks", days: 364 },
];

export const DEFAULT_MENU_PERIOD_DAYS = 28;
export const DEFAULT_MENU_ORDER_PERIOD_DAYS = 52 * 7;

export const getDefaultMenuPeriodDays = (location = "") =>
  location.endsWith("/menu-order")
    ? DEFAULT_MENU_ORDER_PERIOD_DAYS
    : DEFAULT_MENU_PERIOD_DAYS;

export const isMenuEngineeringLocation = (location = "") =>
  location.startsWith("/app/menuEngineering");

// Whole days ending yesterday, so a partial trading day never skews rankings.
// "Today" (0 days) is the exception: midnight today to the end of today.
export const getLastDaysRange = (days, now = new Date()) => {
  if (days === TODAY_PRESET_DAYS) {
    const start = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
      0
    );
    const end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      0
    );
    return {
      start: { long: start, short: Math.floor(start.getTime() / 1000) },
      end: { long: end, short: Math.floor(end.getTime() / 1000) },
    };
  }
  const end = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 1,
    23,
    59,
    59,
    0
  );
  const start = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - days,
    0,
    0,
    0,
    0
  );
  return {
    start: { long: start, short: Math.floor(start.getTime() / 1000) },
    end: { long: end, short: Math.floor(end.getTime() / 1000) },
  };
};
